import { ordinal } from '~/modules/utils/ordinal';

/**
 * Where each singer came, keyed by their place in the panel list rather than by their score.
 *
 * Equal scores share a place, and the singer behind them drops by however many tied above - two who
 * drew are both first, and the next is third. Handing identical scores 1st and 2nd named a winner
 * where the round had not produced one, and which of them got it came down to the order the panels
 * happened to be in.
 */
export function rankByScore(scores: number[]): Record<number, string> {
  const order = scores.map((score, index) => ({ score, index })).sort((a, b) => b.score - a.score);

  const places: Record<number, string> = {};
  let place = 0;

  order.forEach(({ score, index }, position) => {
    if (position === 0 || score !== order[position - 1].score) place = position + 1;

    places[index] = ordinal(place);
  });

  return places;
}
